export enum DisabledPrimaryActionReason {
    MESSAGE_EMPTY = 'MESSAGE_EMPTY',
    MESSAGE_TOO_LONG = 'MESSAGE_TOO_LONG',
    SUBJECT_LINE_EMPTY = 'SUBJECT_LINE_EMPTY',
    RECIPIENT_MISSING_LINKEDIN_PROFILE = 'MISSING_LINKEDIN_PROFILE',
    RECIPIENT_CONNECTION_PENDING = 'CONNECTION_PENDING',
    RECIPIENT_INVALID_EMAIL = 'INVALID_EMAIL',
    EXTENSION_NOT_INSTALLED = 'EXTENSION_NOT_INSTALLED',
    LINKEDIN_MISSING_CONFIG = 'LINKEDIN_MISSING_CONFIG',
    LINKEDIN_NOT_AUTHENTICATED = 'LINKEDIN_NOT_AUTHENTICATED',
    LINKEDIN_SYNCING = 'LINKEDIN_SYNCING',
    EMAIL_NOT_CONNECTED = 'EMAIL_NOT_CONNECTED',
    EMAIL_NOT_AUTHENTICATED = 'EMAIL_NOT_AUTHENTICATED',
    EMAIL_SCOPES = 'EMAIL_SCOPES',
    LINKEDIN_NOT_SUPPORTED_ON_MOBILE = 'LINKEDIN_NOT_SUPPORTED_ON_MOBILE',
}
